import * as React from "react";

import CircularProgress from "@mui/material/CircularProgress";
import MuiButton, { ButtonProps as MuiButtonProps } from "@mui/material/Button";

import { useTheme } from "@mui/material";

export interface ButtonProps extends MuiButtonProps {
  withBorder?: boolean;
  loading?: boolean;
}
const Button: React.FC<ButtonProps> = ({ withBorder, loading, ...props }) => {
  const theme = useTheme();
  const { colors } = theme;

  return (
    <MuiButton
      {...props}
      disabled={props.disabled || loading}
      sx={{
        ...{ border: withBorder ? `1px solid ${colors.grey400}` : "none" },
        ...props.sx,
      }}
    >
      <span style={{ visibility: loading ? "hidden" : "visible" }}>
        {props.children}
      </span>
      {loading && (
        <CircularProgress
          size={24}
          color="inherit"
          thickness={10}
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            marginTop: -12,
            marginLeft: -12,
          }}
        />
      )}
    </MuiButton>
  );
};

export default Button;
